export const messages = {
  moduleNoAccess: {
    title: 'You do not have access to this module',
    adminText: 'Go to Billing plan to manage the module users.',
    staffText:
      'Please contact your administrator to be given access to this module.',
    goToBillingPlanButton: 'Go to billing plan',
    returnToDashboardButton: 'Return to Dashboard',
  },
  unauthorized: {
    default: {
      code: '401',
      title: 'Oops! Something went wrong.',
      description: 'Click the link below to return to the homepage.',
      button: 'Back to homepage',
    },
    external: {
      code: '401',
      title: 'There was a problem with your access',
      description:
        'Your link may have expired. Please try again. If the problem persists, please contact the administrator.',
      button: 'Go back',
    },
  },
} as const
